import { namespace } from 'vuex-class';
import { IUpdateDirectoryState } from './update-directory.types';

export const UpdateDirectory = namespace('contentLibrary/directories/updateDirectory');

export enum EUpdateDirectoryAction {
  Update = 'update',
  UpdateSuccess = 'updateSuccess',
  UpdateFailed = 'updateFailed',
  Reset = 'reset',
}

export enum EUpdateDirectoryMutation {
  SetUpdating = 'setUpdating',
  SetUpdatedDirectory = 'setUpdatedDirectory',
  SetState = 'setState',
}

export const state: IUpdateDirectoryState = {
  updating: false,
  updatedDirectory: null,
};
